import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService, getContext } from '@app/core';
import { Observable, map } from 'rxjs';
import { formatDate } from '@projects/shared/src/app/utils';
import { isNullUndefinedEmpty, momentCustomInstance as moment } from '@projects/shared/src/app/utils/helper';
import { VoiceMails } from '../features/interfaces/VoiceMails';
import { naturalSensitiveSort } from '@projects/shared/src/app/utils/sort';

@Injectable({
  providedIn: 'root',
})
export class CallRecordingService {
  constructor(private httpClient: HttpClient) {}

  getCallRecordingsData(
    from: string,
    to: string,
    limit: Number,
    skip: Number,
    fields: string,
    fieldValues: string,
    criteria: string
  ) {
    const url = `/recordings/calls?StartDate=${from}&EndDate=${to}&Limit=${limit}&Skip=${skip}&Fields=${fields}&FieldValues=${fieldValues}&Criteria=${criteria}`;
    return this.httpClient.get<Array<VoiceMails>>(url).pipe(
      map((data: any) => {
        return {
          totalCount: data.TotalCount,
          callRecordings: data.CallRecordings.map((d: any) => {
            return {
              agentID: isNullUndefinedEmpty(d.AgentID),
              customerFirstName: isNullUndefinedEmpty(d.CustomerFirstName),
              pseudoName: isNullUndefinedEmpty(d.PseudoName),
              skill: isNullUndefinedEmpty(d.Skill),
              termCode: isNullUndefinedEmpty(d.TermCode),
              CreatedOn: d.CreatedOn,
              recordingSid: isNullUndefinedEmpty(d.RecordingSide),
              callSID: isNullUndefinedEmpty(d.CallSid),
              duration: formatDate(d.Duration),
              disposition: isNullUndefinedEmpty(d.Disposition),
              type: isNullUndefinedEmpty(d.Type),
              tfn: isNullUndefinedEmpty(d.TFN),
              callSid: isNullUndefinedEmpty(d.CallSid),
              redactionEnabled: d.RedactionEnabled,
              action: '',
              audioTrack: '',
              isAudioLoading: false,
              isAudioPlaying: false,
              rowDetail: { enabled: false },
              isTranscriptLoading: false,
              isShowTranscript: false,
              transcriptData: [],
            };
          }),
        };
      })
    );
  }

  getSingleCallRecordData(callSid: string): Observable<Blob> {
    const url = `/recordings/calls/get?CallSid=${callSid}`;
    return this.httpClient
      .disableLoader()
      .get(url, { context: getContext('telephony'), responseType: 'blob' })
      .pipe(
        map((res: any) => {
          return new Blob([res], {
            type: 'audio/wav',
          });
        })
      );
  }

  getCallTranscript(callSid: string, isVoicemail: boolean = false) {
    const url = `/recordings/transcript?CallSid=${callSid}&IsVoicemail=${isVoicemail}`;
    return this.httpClient.get(url, { context: getContext('telephony') }).pipe(
      map((data: any) => {
        let sortMessages = naturalSensitiveSort([...data]).asc('SentenceIndex');
        return sortMessages.map((data: any) => {
          let audioStartSeconds = this.roundNumber(data.StartTime, 1);
          let messageDirection = data.MediaChannel;
          return {
            userClass: messageDirection === 1 ? 'reversed' : '',
            message: data.Transcript,
            speaker: isVoicemail ? 'C' : messageDirection === 1 ? 'A' : 'C',
            seconds: audioStartSeconds,
            time: formatDate(audioStartSeconds),
            messageDirection: messageDirection,
            start: data.StartTime,
            end: data.EndTime,
          };
        });
      })
    );
  }

  roundNumber(value: number, decimalPlaces: number): number {
    const multiplier = Math.pow(10, decimalPlaces);
    return Math.round(value * multiplier) / multiplier;
  }
}
